import { render, staticRenderFns } from "./cardBox.vue?vue&type=template&id=098f7be8&"
import script from "./cardBox.vue?vue&type=script&lang=js&"
export * from "./cardBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/card/cardBox.vue"
export default component.exports